// src/pages/Admin/DossierInscription/components/DossierFiltersBar.jsx

import React from "react";
import { FaFilter, FaSearch, FaTimes } from "react-icons/fa";

export default function DossierFiltersBar({
  searchTerm,
  setSearchTerm,
  seasonFilter,
  setSeasonFilter,
  seasons = [],
  selectedGroup,
  setSelectedGroup,
  groups = [],
  validateCmFilter,
  setValidateCmFilter,
  validateLicenceFilter,
  setValidateLicenceFilter,
  validateReglementFilter,
  setValidateReglementFilter,
  filteredCount,
  resetFilters,
}) {
  return (
    <div className="border-b border-slate-200 p-4 dark:border-slate-800 sm:p-5 lg:p-6">
      <div className="flex flex-col gap-3 xl:flex-row xl:items-center xl:justify-between">
        <div>
          <h2 className="text-xl font-bold text-slate-900 dark:text-white">
            Tableau des dossiers
          </h2>

          <p className="mt-1 text-sm leading-6 text-slate-600 dark:text-slate-300">
            {Number(filteredCount || 0).toLocaleString("fr-FR")} dossier
            {filteredCount > 1 ? "s" : ""} affiché{filteredCount > 1 ? "s" : ""}
          </p>
        </div>

        <button
          type="button"
          onClick={resetFilters}
          className="inline-flex items-center justify-center gap-2 rounded-2xl border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-slate-700 shadow-sm transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200 dark:hover:bg-slate-800"
        >
          <FaTimes />
          Réinitialiser
        </button>
      </div>

      <div className="mt-4 grid gap-2 xl:grid-cols-[minmax(260px,1.5fr)_repeat(5,minmax(145px,1fr))]">
        <div className="relative xl:col-span-2">
          <FaSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />

          <input
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Rechercher nom, prénom, email, licence, commune..."
            className="w-full rounded-2xl border border-slate-200 bg-white py-2 pl-9 pr-3 text-sm text-slate-900 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-white"
          />
        </div>

        <select
          value={seasonFilter}
          onChange={(event) => setSeasonFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Toutes saisons</option>
          {seasons.map((season) => (
            <option key={season} value={season}>
              {season}
            </option>
          ))}
        </select>

        <select
          value={selectedGroup}
          onChange={(event) => setSelectedGroup(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Tous groupes</option>
          {groups.map((group) => (
            <option key={group.id} value={group.id}>
              {group.nom}
            </option>
          ))}
        </select>

        <select
          value={validateCmFilter}
          onChange={(event) => setValidateCmFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">CM tous</option>
          <option value="true">CM validé</option>
          <option value="false">CM non validé</option>
        </select>

        <select
          value={validateLicenceFilter}
          onChange={(event) => setValidateLicenceFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Licence tous</option>
          <option value="true">Licence validée</option>
          <option value="false">Licence non validée</option>
        </select>

        <select
          value={validateReglementFilter}
          onChange={(event) => setValidateReglementFilter(event.target.value)}
          className="w-full rounded-2xl border border-slate-200 bg-white px-3 py-2 text-sm font-bold text-slate-700 outline-none transition focus:ring-2 focus:ring-indigo-400 dark:border-slate-700 dark:bg-slate-950 dark:text-slate-200"
        >
          <option value="">Règlement tous</option>
          <option value="true">Règlement validé</option>
          <option value="false">Règlement non validé</option>
        </select>
      </div>

      <div className="mt-4 rounded-2xl border border-indigo-200 bg-indigo-50 px-4 py-3 text-xs leading-5 text-indigo-800 dark:border-indigo-500/20 dark:bg-indigo-500/10 dark:text-indigo-300">
        <span className="inline-flex items-center gap-2 font-bold">
          <FaFilter />
          Astuce :
        </span>{" "}
        les validations peuvent être modifiées directement depuis le tableau. Le
        filtre et l’export Excel reprennent exactement les dossiers affichés.
      </div>
    </div>
  );
}